import { Button, Table, Spinner } from "react-bootstrap";
import TablePaginationBar from "../components/TablePaginationBar";
import { checkPermissionByKey } from "../utils/checkPermissionByKey";
import { config } from "../config/config";
import { getSolutionCoaches } from "../config/url";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useFetchData from "../hooks/useFetchData";

const SolutionCoaches = () => {
  const user = useSelector((state) => state?.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersPerPage, setUsersPerPage] = useState(10);

  const businessId = user.user?.businessId;
  const businessIdentifier = user.user?.businessIdentifier;
  
  const data = useFetchData(
    `${getSolutionCoaches}?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
    config
  );

  // Update users when data is loaded
  useEffect(() => {
    // Only update users when loading is complete
    if (data?.loading === false) {
      if (Array.isArray(data?.data) && data.data.length > 0) {
        setUsers(data.data);
      } else {
        // Explicitly set empty array when response comes back with no users or null/undefined
        setUsers([]);
      }
    }
  }, [data]);

  // Update currentUsers whenever users or currentPage changes
  useEffect(() => {
    if (users.length > 0) {
      const indexOfLastUser = currentPage * usersPerPage;
      const indexOfFirstUser = indexOfLastUser - usersPerPage;
      setCurrentUsers(users.slice(indexOfFirstUser, indexOfLastUser));
    } else {
      setCurrentUsers([]);
    }
  }, [currentPage, users, usersPerPage]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const navigate = useNavigate();

  return (
    <div className="app-page">
      <div className="bg-white rounded shadow-sm">
        <div className="app-page-toolbar">
          <h2 className="app-page-title">Solution Coaches</h2>
          <button
            className="app-filter-action-btn"
            onClick={() => navigate('/solution-coach/add-solution-coaches')}
          >
            Add New
          </button>
        </div>
        {data?.loading === true ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <div className="mt-3 text-muted">Loading solution coaches...</div>
          </div>
        ) : users.length === 0 ? (
          <div className="text-center p-4">No solution coaches found.</div>
        ) : (
          <>
            <Table
              className="mb-0"
              hover
              responsive
              style={{ borderCollapse: "collapse", borderSpacing: 0 }}
            >
              <thead
                style={{
                  backgroundColor: "#064260",
                  color: "white",
                  height: "50px",
                  textAlign: "center",
                }}
              >
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Video</th>
                  <th   style={{minWidth: "160px", maxWidth: "160px", width: "160px"}}>Action</th>
                </tr>
              </thead>
              <tbody
                style={{
                  color: "#575757",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                {currentUsers &&
                  currentUsers.map((user, index) => {
                    return (
                      <tr key={user._id} style={{ backgroundColor: "white" }}>
                        <td>
                        {(index + 1 + (currentPage - 1) * usersPerPage)
                          .toString()
                          .padStart(4, "0")}
                        </td>
                        <td>{user.name}</td>
                        <td>
                          <img
                            src={user.profile_image_url}
                            alt={user.name}
                            style={{ width: "70px", height: "70px", borderRadius: "50%" }}
                            onError={(e) => {
                              e.target.src = "/placeholder-image.png";
                            }}
                          />
                        </td>
                        <td>
                          {user.intro_video_url && (
                            <video
                              width="150"
                              height="90"
                              controls
                              style={{ borderRadius: "8px" }}
                              onError={(e) => {
                                console.error("Video failed to load", e);
                              }}
                            >
                              <source src={user.intro_video_url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          )}
                        </td>
                        <td>
                          {checkPermissionByKey(
                            user,
                            "userManagement",
                            "UserList"
                          ) && (
                            <button
                              className="app-view-btn"
                              onClick={async () => {
                                try {
                                  navigate(`/solution-coach/${user.id}`, {
                                    state: {
                                      user,
                                    },
                                  });
                                } catch (error) {
                                  console.error("🚀 -> onClick={ -> error:", error);
                                }
                              }}
                            >
                              View
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
            <TablePaginationBar
              currentPage={currentPage}
              totalItems={users.length}
              rowsPerPage={usersPerPage}
              onPageChange={paginate}
              onRowsPerPageChange={(n) => {
                setUsersPerPage(n);
                setCurrentPage(1);
              }}
              rowsPerPageOptions={[10, 25, 50]}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SolutionCoaches;
